module.exports = __webpack_public_path__ + "static/media/developer.295b125e.png";